<template>
  <div>
    <div class="other-mail-operation-area" v-if="$permission('ticket:edit')">
      <gj-button
        class="color333"
        type="text" @click="setStarMark">
        <div class="flex align-center">
          <img v-if="!data.isStar" src="../../../../../assets/images/crm/collection.png" class="gj-pointer gj-mr4">
          <img v-else src="../../../../../assets/images/crm/collection2.png" class="gj-pointer gj-mr4">
          <span>{{!data.isStar?'': '取消'}}标记重要邮件</span>
        </div>
      </gj-button>
    </div>
    <div class="other-content">
      <div style="display: flex; flex-direction: column; width: 100%; height: 100%">
        <div class="other-email">
          <div class="flex align-center" style="margin-bottom: 4px;">
            <span class="color333 weight600 gj-mr4">{{data.emailName}}</span>
            <span class="color999 gj-mr8">&lt;{{data.emailAddress||'无邮箱'}}&gt;</span>
            <i class="iconfont iconcollection size14"></i>
          </div>

          <div style="height: 18px;margin-bottom: 4px;"><span class="color666 label" style="margin-right: 12px">邮件主题</span><span class="color999">{{data.subject||'-'}}</span></div>

          <div style="margin-bottom: 4px;">
            <span class="color666 label" style="padding-right: 10px;">收件人邮箱</span>
            <span class="color999">{{data.receiverEmailAddress | defaultShow}}</span>
          </div>

          <div class="flex gj-mb10">
            <span class="color666 label" style="padding-right: 10px;">附件</span>
            <div>
              <template v-if="isMeaningful(data.attachments) && data.attachments.length > 0">
                <template v-for="(attItem, index) in data.attachments">
                  <span :key="index" class="gj-mr12">
                    <gj-link type="text" icon="el-icon-document"  @click="downloadAttFile(attItem.id)" class="gj-mr8 colorBlue">{{attItem.name}}</gj-link>
                  </span>
                </template>
              </template>
              <template v-else>-</template>
            </div>
          </div>
        </div>
        <div class="reply-detail">
          <div style="display: flex; flex-direction: column; width: 100%; height: calc(100vh - 366px);">
            <div class="reply-message-content">
              <div class="reply-message">
                <div class="reply-message-date">
                  <div v-if="data.htmlContent" v-html="data.htmlContent" ref="htmlContent"></div>
                  <div v-else v-html="data.contentText" ref="htmlContent" class="html-content-text"></div>
                </div>
              </div>
            </div>
            <!-- <div>
              <div class="reply-message-template">
                <div style="width: 100%; margin-right: 10px;">
                  <gj-input v-model="subject" placeholder="请输入邮件主题" width="100%"></gj-input>
                </div>
              </div>
              <div style="padding: 8px 10px">
                <gj-textarea
                    v-model="sendMessage"
                    :styles="{height: textareaFocusFlag ? '215px' : '30px'}"
                    placeholder="请将你的回复限制在4000字以内"
                    @focus="textareaFocusFlag = true"
                ></gj-textarea>
                <template v-if="uploadAttFiles.length > 0">
                  <div class="upload-att">
                    <template v-for="(attItem, index) in uploadAttFiles">
                      <div :key="index">
                        {{attItem.name}}
                        <i class="el-icon-close att-close" @click="removeAttFile(attItem.attId)"></i>
                      </div>
                    </template>
                  </div>
                </template>
                <el-row :style="{paddingTop: uploadAttFiles.length > 0 ? 'unset' : '10px'}">
                  <el-col :span="12">
                    <gj-upload-attach
                        containerType="mailReply"
                        :file-list="uploadAttFiles"
                    ></gj-upload-attach>
                  </el-col>
                  <el-col :span="12" style="text-align: right; padding: 0">
                    <gj-button
                        @click="textareaFocusFlag = false"
                        :style="{display: textareaFocusFlag ? 'inline-block' : 'none'}">收起</gj-button>
                    <gj-button :loading="sendLoading" type="primary" @click="send">发送</gj-button>
                  </el-col>
                </el-row>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {isMeaningfulMixin} from "../../../../../minxins";
  import {isMeaningful, isMeaningless} from "../../../../../utils/common";
  import {mailTypeEnum, mailTypeStatusEnum} from "./enum";
  import {getAmazonEmailDetail, marketEmailTemplate, sendMail, updateStatus, setTicketCollection} from "../../../../../api/crm";
  import {downloadAttFile} from "../../../../../api/common";

  export default {
    name: "app-mail-reply-other-content",
    mixins: [isMeaningfulMixin],
    props: {
      item: null,
      mailType: null,
      marketId: null,
    },
    watch: {
      item: {
        immediate: true,
        deep: true,
        handler(value) {
          this.data = {};
          if (isMeaningful(value) && this.mailType === mailTypeEnum.AMAZON_EMAIL) {
            this.loading = true;
            getAmazonEmailDetail(value.id)
              .then((data) => {
                this.subject = data.subject;
                this.data = data;
                if (isMeaningful(this.data) && isMeaningful(this.data.messages) && this.data.messages.length > 0) {
                  this.data.messages.forEach(v => this.$set(v, 'more', false))
                }
              }).complete(() => this.loading = false);
          }
        }
      }
    },
    data() {
      return {
        loading: false,
        TrackingLoading: false,
        DoneLoading: false,
        sendLoading: false,
        mailTypeStatusEnum: mailTypeStatusEnum,
        emailTemplate: null,
        data: {},
        textareaFocusFlag: false,
        sendMessage: null,
        uploadAttFiles: [],
        subject: '',  // 主体
      }
    },
    methods: {
      // 设置为重要图标
      setStarMark() {
        let params = {
          ticketIds: [this.data.id],
          type: !this.data.isStar ? 1 : 0
        }
        setTicketCollection(params).then(res => {
          this.$gjMessage.success(res.data);
          this.loading = true;
          getAmazonEmailDetail(this.data.id)
            .then((data) => {
              this.data = data;
              if (isMeaningful(this.data) && isMeaningful(this.data.messages) && this.data.messages.length > 0) {
                this.data.messages.forEach(v => this.$set(v, 'more', false))
              }
            }).complete(() => this.loading = false);
          this.$emit('closeReview');
        })
      },
      updateStatus(status) {
        this[status + 'Loading'] = true;
        updateStatus(this.item.id, status)
          .then(() => {
            this.$gjMessage.success('操作成功');
          }).complete(() => this[status + 'Loading'] = false)
      },
      changeEmailTpl() {
        this.sendMessage = this.emailTemplate;
        this.textareaFocusFlag = true;
      },
      send() {
        if (isMeaningless(this.sendMessage) || isMeaningless(this.subject)) {
          this.$gjMessage.error('邮件内容和主题不能为空');
          return;
        }
        this.sendLoading = true;
        sendMail({
          id: this.item.id,
          content: this.sendMessage,
          subject: this.subject,
          attachments: isMeaningful(this.uploadAttFiles) ? this.uploadAttFiles.map(v => ({id: v.attId, name: v.name})) : [],
        }).then((res) => {
          this.$gjResponseHandle(res, () => {
            this.$gjMessage.success('发送成功');
            this.sendMessage = '';
            this.textareaFocusFlag = false;
            this.loading = true;
            getAmazonEmailDetail(this.data.id)
              .then((data) => {
                this.data = data;
                if (isMeaningful(this.data) && isMeaningful(this.data.messages) && this.data.messages.length > 0) {
                  this.data.messages.forEach(v => this.$set(v, 'more', false))
                }
              }).complete(() => this.loading = false);
          })
        }).complete(() => this.sendLoading = false)
      },
      downloadAttFile(attId) {
        downloadAttFile(attId);
      },
      removeAttFile(attId) {
        this.uploadAttFiles = this.uploadAttFiles.filter(v => v.attId !== attId);
      }
    }
  }
</script>

<style lang="scss" scoped>

  .other-mail-operation-area {
    display: flex;
    justify-content: space-between;
    height: 32px;
    line-height: 32px;
    border-bottom: 1px solid #E4E5E6;
  }
  .reply-detail a {
    cursor:pointer;
    color: #1F6EEF;
  }
  .other-content {
    flex: 1;
    max-height: calc(100vh - 137px);
    border-right: 1px solid #ddd;
  }
  .label {
    text-align: right;
    display: inline-block;
    width: 61px;
  }
  .color666 {
    color: #666;
  }
  .color444 {
    color: #333;
  }
  .other-email {
    margin-left: 10px;
    margin-right: 10px;
    padding-top: 10px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 10px;
    box-sizing: border-box;
  }
  .reply-detail {
    flex: 1;
  }
  .reply-detail /deep/ .el-alert {
    padding: 4px 16px;
  }
  .message-mb15 {
    margin-bottom: 15px;
  }
  .reply-message {
    /*width: 700px;*/
    // max-width: 65%;
  }
  .reply-message-date {
    color: #666;
    margin-bottom: 6px;
    .html-content-text {
      white-space: pre-wrap;
    }
  }
  .reply-message-content {
    //border-bottom: 1px solid #ddd;
    flex: 1;
    padding: 10px;
    box-sizing: border-box;
    overflow: hidden;
    //background: #f6f7f8;;
    &::-webkit-scrollbar-track{
      background: #f6f7f8;
    }
  }
  .reply-message-content:hover {
    overflow-y: overlay;
  }
  .reply-message-content-item {
    white-space: pre-wrap;
    padding: 10px 16px 10px 10px;
    box-shadow: 0 4px 8px 0 rgba(7,17,27,.05);
    border-radius: 4px;
  }
  .reply-message-item--right {
    justify-content: flex-end;
    display: flex;
  }
  .reply-message-date--right {
    text-align: right;
  }
  .upload-att {
    padding-top: 10px;
    display: flex;
  }
  .upload-att > div {
    margin-right: 15px;
  }
  .att-close {
    cursor: pointer;
  }
  .reply-message-template {
    border-bottom: 1px solid #ddd;
    display: flex;
    padding: 8px 0 8px 10px;
  }
  .detail-head > div {
    display: inline-block;
    padding: 8px 12px;
    cursor: pointer;
  }
</style>
